import { useCallback, useState } from 'react';
import { useLocalStorage } from '@rehooks/local-storage';
import moment from 'moment/moment';

const daysBetweenReminders = 21;

export const useShouldShowPrompt = (feature: string) => {
  const [now] = useState(new Date());
  const [lastReminded, setLastReminded] = useLocalStorage<string | null>(
    `${feature}/lastAsked`,
    null
  );
  const [originalLastReminded] = useState(lastReminded);

  const shouldShowModal =
    !originalLastReminded ||
    moment(now).subtract(daysBetweenReminders, 'days') > moment(originalLastReminded);

  const markReminded = useCallback(() => {
    setLastReminded(new Date().toISOString());
  }, [setLastReminded]);

  return { markReminded: shouldShowModal ? markReminded : null };
};
